import React from 'react'
import { ElementList } from './ElementList'
import { PickingDiffElement } from './PickingDiffElement'
import { PickingDiff } from '../../../interfaces/PickingValidate/PickingDiff'
import { PickingDiffFilter } from '../../../interfaces/PickingValidate/PickingDiffFilter'

interface PickingDiffListProps {
  rows: PickingDiff[]
  totals: PickingDiff
  filters: PickingDiffFilter
  handleUpdateElement: (element: PickingDiff) => void
  typePickingRouteId: number
  orderCancellationRequest: boolean
}

export const PickingDiffList: React.FC<PickingDiffListProps> = ({
  rows: positionList,
  totals,
  filters,
  handleUpdateElement,
  typePickingRouteId,
  orderCancellationRequest
}) => {
  return (
    <ElementList items={positionList} filters={filters} dir='vertical'>
      {(item) => (
        <PickingDiffElement
          element={item}
          totals={totals}
          handleUpdateElement={handleUpdateElement}
          typePickingRouteId={typePickingRouteId}
          orderCancellationRequest={orderCancellationRequest}
        />
      )}
    </ElementList>
  )
}
